import React from "react"
import ReactDOM from "react-dom"
import NumberCardsContainer from "./number-cards-container-component"

export default class NumberCardsContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    this.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<NumberCardsContainer {...self.modelJson} lang={document.body && document.body.dataset.language} />, self.elem)
  }
}
